import { parseISO } from "date-fns";

export function getRequestLogs({
  projectId,
  apiEndpointId,
  userId,
  httpMethodCode,
  httpStatusCode,
  responseTimeCode,
  fromDate,
  toDate,
  pageNumber,
  pageSize,
}) {
  return window.axios
    .get(`/hub/v1/request-logs`, {
      params: {
        projectId,
        apiEndpointId,
        userId,
        httpMethodCode,
        httpStatusCode,
        responseTimeCode,
        fromDate: fromDate ? parseISO(fromDate).toISOString() : null,
        toDate: toDate ? parseISO(toDate).toISOString() : null,
        pageNumber,
        pageSize,
      },
    })
    .then((response) => response.data);
}

export function getRequestLogSearchParams() {
  return window.axios
    .get(`/hub/v1/request-logs/items`)
    .then((response) => response.data);
}
